import Pessoa from 'model/pessoa/Pessoa';
import { Page } from 'model/Page';
import { QueryParamsFormatter } from '../../QueryParamsFormatter';
import { ApiAxios } from '../ApiAxios';
import { CachePessoas } from 'store/Pessoas/CachePessoas';
import { Api } from '../Api';


export interface PessoasQueryParams {
  idInstitucional?: string[]
  nome?: string
}

export class ApiPessoas {
  /** 
   * @deprecated Provavelmente será excluído no futuro
   */
  static async pessoasByIdsInstitucionais(idsInstitucionais: string[]): Promise<Pessoa[]> {
    const pessoas: Pessoa[] = []
    const idsABuscar: string[] = []

    idsInstitucionais.forEach(id => {
      const cache = CachePessoas.instance.get(id)
      if (cache !== undefined) {
        pessoas.push(cache);
      } else {
        idsABuscar.push(id)
      }
    });

    if (idsABuscar.length === 0) {
      return pessoas;
    }

    const resultado = await this.pessoas({idInstitucional: idsABuscar});
    return [...pessoas, ...resultado];
  }

  /**
   * @deprecated Provavelmente será excluído no futuro
   *             Utilize getPessoas no lugar
   */
  static async pessoas(query: PessoasQueryParams): Promise<Pessoa[]> {
    const pessoas: Pessoa[] = []

    const queryParams = QueryParamsFormatter.format(query)
    const response = await ApiAxios.instance.get(`reinos/${Api.REINO_PADRAO}/pessoas?${queryParams}`)

    const data: Page<Pessoa> = response.data;
    data.content.forEach(element => {
      CachePessoas.instance.add(element)
      pessoas.push(element)
    });

    return pessoas
  }

  static async getPessoas(query: PessoasQueryParams): Promise<Page<Pessoa>> {
    const queryParams = QueryParamsFormatter.format(query);
    const response = await ApiAxios.instance.get(`reinos/${Api.REINO_PADRAO}/pessoas?${queryParams}`)
    
    return response.data;
  }
}
